// extracted by mini-css-extract-plugin
module.exports = {"sticky-notes":"StickyNotes_sticky-notes__7cpse","stickyNotes":"StickyNotes_sticky-notes__7cpse","note":"StickyNotes_note__u5hgV"};